module.exports = __webpack_public_path__ + "img/american_express.a4b1731b.svg";